import { Button } from "components/DesignSystem/Button/Button";
import { EmptySalesTax } from "components/Illustrations/EmptySalesTax";
import { Link } from "react-router-dom";

export const NoRegistrationsEmptyState = ({
  registrationsUrl,
}: {
  registrationsUrl: string;
}) => {
  return (
    <div className="t-flex t-h-full t-flex-col t-items-center t-justify-center">
      <EmptySalesTax />
      <p className="t-text-text-100 t-text-body t-font-medium t-mb-0 t-mt-6">
        No returns yet
      </p>
      <p className="t-text-text-30 t-text-body-sm t-mb-0 t-mt-1 t-max-w-md t-text-center">
        Returns are generated from a live permit, and you aren’t registered
        anywhere yet. Once a state issues one, we create every return on its
        schedule automatically — you’ll never add one by hand.
      </p>
      <Link to={registrationsUrl}>
        <Button customType="secondary" size="small" className="t-mt-4">
          Go to Registrations
        </Button>
      </Link>
    </div>
  );
};
